var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('uploader',{staticClass:"uploader",attrs:{"label":_vm.$t('import.uploadFilePlaceholder'),"endpoint":_vm.endpoint,"accepted-files":['application/zip']},on:{"uploaded":_vm.onUploaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }